import React from 'react';
import ReactDOM from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import stylisPluginRtl from 'stylis-plugin-rtl';
import './index.css';
import './styles/global.css';
import './styles/fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rtlCache = createCache({ key: 'muirtl', stylisPlugins: [stylisPluginRtl] });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CacheProvider value={rtlCache}>
      <App />
    </CacheProvider>
  </React.StrictMode>
);

reportWebVitals();
